import { Factory } from 'rosie';

Factory.define('UserActivation').attr('name', 'USER_ACTIVATION');

Factory.define('UserActivationWithDefaults').extend('UserActivation');



// WEBPACK FOOTER //
// ./factories/location/user_activation.js